import { render } from "./addroom.vue?vue&type=template&id=53009299&scoped=true"
import script from "./addroom.vue?vue&type=script&lang=js"
export * from "./addroom.vue?vue&type=script&lang=js"

import "./addroom.vue?vue&type=style&index=0&id=53009299&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53009299"]])

export default __exports__